import { defineMessages } from "@/i18n";
import en from "./en";

export const commonMessages = defineMessages("common", en);
